import {decryptPasswordBasedBackend} from "./encryptionCrypto";
import {APP_SALT} from "../../conf";

/**
 * Función para manejar la respuesta del servicio y desencriptar los datos.
 * @param resp La respuesta del servicio que contiene el IV y el texto cifrado.
 * @returns El texto desencriptado.
 */
export function interceptorResponse(resp: string | null) {
    if (resp === null) {
        return null
    }
    // Dividir la respuesta en IV y texto cifrado
    const part = resp.split(':');

    if (part.length < 3) {
        return null;
    }

    const salt = part[0];
    const ivBase64 = part[1]; // IV en Base64
    const cipherText = part[2]; // Texto cifrado
    // Desencriptar el texto cifrado usando la clave de encriptación y el IV
    return decryptPasswordBasedBackend(cipherText, APP_SALT, salt, ivBase64);
}
